import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BannerCarousel from "../components/BannerCarousel";
import Products from "../components/Products";
import Category from "../components/Category";

export default function Dashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);






  return (
    <>
      <style>{`
        *{ box-sizing:border-box; }
        html, body, #root{
          height:100%;
          width:100%;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial;
        }
        :root{
          --bg:#0b1020;
          --text: rgba(255,255,255,.92);
        }
        body{
          margin: 0;
          background:
            radial-gradient(900px 600px at 10% 10%, rgba(109,91,255,.16), transparent 55%),
            radial-gradient(900px 600px at 90% 25%, rgba(34,211,238,.14), transparent 55%),
            linear-gradient(180deg, #070a16, var(--bg));
          color: var(--text);
        }
      `}</style>



      {/* ✅ Category SECOND */}
      <Category />

      {/* ✅ Products BELOW */}
      <Products />
    </>
  );
}
